import { render, staticRenderFns } from "./GotoGroup.vue?vue&type=template&id=3d605d4e&"
import script from "./GotoGroup.vue?vue&type=script&lang=js&"
export * from "./GotoGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports